import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAMES } from '../constants';

interface UnsavedChangesState {
  hasUnsavedChanges: boolean;
  blockedPath: string;
}

const initialState: UnsavedChangesState = {
  hasUnsavedChanges: false,
  blockedPath: '',
};

const unsavedChangesSlice = createSlice({
  name: SLICE_NAMES.UNSAVED_CHANGES,
  initialState,
  reducers: {
    setHasUnsavedChanges: (state, action: PayloadAction<boolean>) => {
      state.hasUnsavedChanges = action.payload;
    },
    blockNavigation: (state, action: PayloadAction<string>) => {
      state.blockedPath = action.payload;
    },
    clearBlockedNavigation: state => {
      state.blockedPath = '';
    },
    resetUnsavedChanges: () => initialState,
  },
});

export const {
  setHasUnsavedChanges,
  blockNavigation,
  clearBlockedNavigation,
  resetUnsavedChanges,
} = unsavedChangesSlice.actions;
export const unsavedChangesReducer = unsavedChangesSlice.reducer;
